import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";

import { Roles } from "@juristech/contracts/auth/roles.constants";

import { TokenService } from "../services/token.service";

/**
 * Restricts a route to super-admin users only.
 *
 * Composes after {@link authGuard} (which admits both admin and super-admin):
 * non-super-admin sessions are redirected to `/dashboard` rather than the login
 * page, since they are already authenticated admins — they simply lack access
 * to this area (DeedCore rules authoring).
 *
 * @returns `true` for a super-admin session, otherwise a `UrlTree` to `/dashboard`.
 */
export const superAdminGuard: CanActivateFn = () => {
  const tokenService = inject(TokenService);
  const router = inject(Router);

  const roles: string[] = tokenService.decodeToken()?.roles ?? [];
  if (roles.includes(Roles.SUPER_ADMIN)) {
    return true;
  }

  return router.createUrlTree(["/dashboard"]);
};
